import { Check } from '@mui/icons-material'
import {
  ButtonProps,
  ListItemIcon,
  MenuItem as MuiMenuItem,
  MenuItemProps as MuiMenuItemProps,
  alpha,
  css,
  styled,
} from '@mui/material'
import { FC, ReactNode } from 'react'

import MenuItemText from './MenuItemText'

interface MenuItemProps extends MuiMenuItemProps {
  color?: ButtonProps['color']
  primary?: ReactNode
  secondary?: ReactNode
  showSelectedCheck?: boolean
  startIcon?: ReactNode
}

const MenuItem: FC<MenuItemProps> = ({
  children,
  color,
  primary,
  secondary,
  showSelectedCheck,
  startIcon,
  ...props
}) => {
  return (
    <StyledMenuItem color={color} {...props}>
      {startIcon && <ListItemIcon>{startIcon}</ListItemIcon>}

      {primary && (
        <MenuItemText
          color={color}
          primary={primary}
          primaryTypographyProps={{ fontWeight: 500 }}
          secondary={secondary}
        />
      )}

      {children}

      {showSelectedCheck && (
        <ListItemIcon sx={{ minWidth: '20px !important', ml: 'auto !important' }}>
          {props.selected && <Check color={color ?? 'primary'} fontSize="small" />}
        </ListItemIcon>
      )}
    </StyledMenuItem>
  )
}

const StyledMenuItem = styled(MuiMenuItem)`
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  white-space: break-spaces;

  ${({ color, theme }) =>
    color &&
    css`
      color: ${theme.palette[color].main};

      &:hover {
        background-color: ${alpha(theme.palette[color].main, 0.15)};
        color: ${theme.palette[color].contrastText};

        /* & .MuiListItemIcon-root {
          color: ${theme.palette[color].contrastText};
        }

        & .MuiTypography-root {
          color: ${theme.palette[color].contrastText};
        } */
      }

      & .MuiListItemIcon-root {
        color: ${theme.palette[color].main};
      }

      & .MuiTypography-root {
        color: ${theme.palette[color].main};
      }
    `}
`

export default MenuItem
